import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import {
  MDBContainer,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
  MDBBtn,
  MDBIcon,
  MDBInput,
  MDBCheckbox
}
  from 'mdb-react-ui-kit';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom'; // Import useHistory for navigation
import { loginSuccess, logout } from '../slices/authSlice';
import { selectAuth } from '../slices/authSlice';
import { useSelector, useDispatch } from 'react-redux'


// Function to handle test button click
const handleTestButtonClick = async () => {
  try {
    const response = await axios.get('/api/test'); // Call the /test endpoint
    console.log('Test Response:', response.data); // Log the response data
  } catch (error) {
    console.error('Error calling /api/test:', error); // Log any errors
  }
};

const GreenTab = styled(MDBTabsLink)`
    background-color: green; /* Change to your desired shade of green */
    color: white; /* Change text color if needed */
`;

function BrancheLoginPage() {



  const [errorMessage, setErrorMessage] = useState(''); // State for error message
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [username, setUsername] = useState(''); // State for password
  const [password, setPassword] = useState(''); // State for password

  const { isAuthenticated, userInformation } = useSelector(selectAuth);
  const dispatch = useDispatch()

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
    }

    setValidated(true);
    const api = '/api/loginbranche'

    // Perform login
    try {
      const response = await axios.post(api, {
        username: username, // Use the selected member's ID
        password: password // Use the password entered
      });

      // If login is successful, save session status and redirect
      if (response.status === 200) {
        // Save session status if needed (e.g., using localStorage or context)
        // localStorage.setItem('session', JSON.stringify(response.data)); // Example
        console.log(response.data)
        dispatch(loginSuccess(response.data))
        navigate('/branche');  // Redirect to /home
      }
    } catch (error) {
      // Handle error and show message
      if (error.response) {
        setErrorMessage(error.response.data.message || 'Login failed. Please try again.');
      } else {
        setErrorMessage('An error occurred. Please try again.');
      }
    }
  };





  return (
    <Container className="my-3">


      <Form noValidate validated={validated} onSubmit={handleSubmit}>

        <Form.Group controlId="validationCustom08">
          <Form.Label className="fw-bold">Username</Form.Label>
          <Form.Control
            placeholder="username"
            required onChange={(e) => setUsername(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mt-3" controlId="validationCustom09">
          <Form.Label className="fw-bold">Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Password"
            required onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Group>
        {errorMessage && <div className="text-danger">{errorMessage}</div>} {/* Display error message */}

        {/* <Button variant="secondary" onClick={handleTestButtonClick} className="my-2">
  Test
</Button> */}

        <div className="my-4 d-grid gap-2">
          <Button variant="success" type="submit">Sign in</Button>
        </div>
      </Form>

    </Container>
  );
}

export default BrancheLoginPage;